import {apiClient} from "../connection/BlinkApiClient";
import type {StoreId} from "../../stem-core/state/State";
import {PaymentStatusDependentStore} from "./misc/StoreUtils";
import {PaymentMethod} from "./PaymentMethodStore";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {field} from "../../stem-core/state/StoreField";
import {Currency} from "../../stem-core/localization/CurrencyStore";
import {Money} from "../../stem-core/localization/Money";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {StemDate} from "../../stem-core/time/Date";
import {Merchant} from "./MerchantStore";
import {UserProfile} from "./UserProfileStore";
import {Wallet} from "./WalletStore";
import type {PaymentType} from "./PaymentStore";

@makeEnum
export class TopUpStatus extends BaseEnum {
    static NOT_PROCESSED;
    static FAILED;
    static SUCCEEDED;
    static REVERTED;
}

@globalStore
export class TopUpPayment extends BaseStore("TopUpPayment", {}, PaymentStatusDependentStore) {
    static Source = {
        PAYMENT_METHOD: "payment_method",
        CREDIT: "blink_credit",
    };

    @field("Merchant") merchant: Merchant;
    @field("UserProfile") user: UserProfile;
    @field("PaymentMethod") paymentMethod: PaymentMethod;
    @field(Date) createdAt: StemDate;
    @field(TopUpStatus) status: TopUpStatus;
    // Set when the top-up paid for a resource directly; null for a plain wallet top-up
    @field(String) resourceType: typeof PaymentType[keyof typeof PaymentType] | null;
    @field(String) resourceId: string | null;
    @field(Boolean) isAutomatic: boolean;
    // How the top-up was started (payments/models/topup_payment.py TopUpPaymentSourceEnum)
    @field(String) source: string;
    // The payment processor's own id for the charge; null until it has one
    @field(String) paymentProcessorChargeId: string | null;

    declare currencyId: number;
    declare amount: number;
    declare paymentMethodId: number;


    // TODO @types @cleanup this inherits from MoneyObject, but for the other shit in PaymentStatusDependentStore
    getCurrency(): Currency | undefined {
        return Currency.get(this.currencyId);
    }

    getAmount(): Money {
        const currency = this.getCurrency();
        return new Money(this.amount, currency);
    }
    // TODO @branch other fields are still required

    // TODO @cleanup deprecate
    getPaymentMethod(): PaymentMethod | undefined {
        return PaymentMethod.get(this.paymentMethodId);
    }
}

export async function apiUserTopUp(amount: number, paymentMethod: PaymentMethod, userWallet: Wallet): Promise<TopUpPayment> {
    const response = await apiClient.post("/top_up_payments/top_up", {
        amount,
        paymentMethodId: paymentMethod.id,
        walletId: userWallet.id,
    });
    return TopUpPayment.loadObject(response);
}

// AdminChargeIdRequest (api/admin_api/views/payments.py)
export interface AdminChargeIdRequest {
    chargeId: StoreId;
}

export async function apiAdminMarkChargeFailed(request: AdminChargeIdRequest): Promise<any> {
    return apiClient.post("/admin/top_up_payments/edit_status_failed", request);
}
